import { getSessionId } from './session';
import { serializeLogData } from './sanitize';

const ENDPOINT = '/__dev_logs';
const FLUSH_INTERVAL_MS = 400;
const FLUSH_BATCH_SIZE = 50;
const MAX_LINE_CHARS = 8000;

let queue = [];
let flushTimer = null;
let initialized = false;

export function formatDevLogLine(level, module, message, data, traceId) {
  const timestamp = new Date().toISOString().replace('T', ' ').slice(0, 19);
  const sessionId = getSessionId() || '-';
  const tracePart = traceId ? `|trace:${traceId}` : '';
  const moduleName = module || 'App';
  const serialized = serializeLogData(data);
  const suffix = serialized ? ` | ${serialized}` : '';
  return truncateLine(`${timestamp} [${level.toUpperCase()}] [sess:${sessionId}${tracePart}|user:] [${moduleName}] ${message}${suffix}`);
}

function truncateLine(line) {
  if (line.length <= MAX_LINE_CHARS) {
    return line;
  }
  return `${line.slice(0, MAX_LINE_CHARS)}…`;
}

function sendLines(lines, keepalive = false) {
  if (!lines.length) {
    return;
  }

  const payload = JSON.stringify({ lines });
  if (keepalive && navigator.sendBeacon) {
    const blob = new Blob([payload], { type: 'application/json' });
    navigator.sendBeacon(ENDPOINT, blob);
    return;
  }

  fetch(ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: payload,
    keepalive,
  }).catch(() => {
    // dev 日志写入失败时不打扰业务
  });
}

export function flushDevFileLogs(keepalive = false) {
  if (!queue.length) {
    return;
  }

  const lines = queue.splice(0, FLUSH_BATCH_SIZE);
  sendLines(lines, keepalive);

  if (queue.length) {
    scheduleDevFileFlush();
  }
}

function scheduleDevFileFlush() {
  if (flushTimer) {
    return;
  }

  flushTimer = window.setTimeout(() => {
    flushTimer = null;
    flushDevFileLogs(false);
  }, FLUSH_INTERVAL_MS);
}

export function enqueueDevLogLine(line, options = {}) {
  if (!import.meta.env.DEV || !line) {
    return;
  }

  if (!initialized) {
    initDevFileSink();
  }

  queue.push(line);
  if (queue.length >= FLUSH_BATCH_SIZE) {
    flushDevFileLogs(false);
    return;
  }

  scheduleDevFileFlush();
}

export function initDevFileSink() {
  if (!import.meta.env.DEV || initialized) {
    return;
  }

  initialized = true;
  window.addEventListener('beforeunload', () => flushDevFileLogs(true));
  window.addEventListener('pagehide', () => flushDevFileLogs(true));
}
